import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useCollapsibleSectionsContext } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { CollapsibleSection } from "~/components/AssetModalV2/InfoPanel/components/CollapsibleSection";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { usePublicClipMetadata } from "~/swr-hooks/clips/usePublicClipMetadata";
import { CameraDetailsSection } from "./CameraDetailsSection";
export const PublicExifCollapsibleSection = /*#__PURE__*/ memo(()=>{
    const clipId = useSelector(centralizedClipIdSelector);
    const { shortId } = useShortIdContext();
    const { data: clipMetadata } = usePublicClipMetadata({
        clipId,
        shortId
    });
    const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
    const isExpanded = expandedSections["exif"];
    const onOpenChange = useCallback(()=>{
        toggleSection("exif");
    }, [
        toggleSection
    ]);
    if (!clipMetadata) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CollapsibleSection, {
        title: "Exif",
        isExpanded: isExpanded,
        onOpenChange: onOpenChange,
        "data-testid": "EXIF_SECTION",
        children: /*#__PURE__*/ _jsx(CameraDetailsSection, {
            clipMetadata: clipMetadata.data
        })
    });
});
PublicExifCollapsibleSection.displayName = "PublicExifCollapsibleSection";
